import { createContext, type Dispatch, type SetStateAction } from 'react';
import { type RectReadOnly } from 'react-use-measure';

interface UseIntroGuideReturnType {
  isFirstVisit?: boolean;
  activeStep: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
  highlightComponentRect: RectReadOnly | null;
  setHighlightComponentRect: Dispatch<SetStateAction<RectReadOnly | null>>;
  toNextStep: () => void;
  isIntroActive: boolean;
  setIsIntroActive: Dispatch<SetStateAction<boolean>>;
  activeGroup: string | null;
  setActiveGroup: Dispatch<SetStateAction<string | null>>;
  startOnboarding: (groupName: string) => void;
  stopOnboarding: () => void;
  registerStepCallback: (step: number, fn: () => void) => void;
  finishIntroPlants: boolean;
  finishOnboarding: () => void;
  isFinishOnboarding: boolean;
  helpIconRef: (node: HTMLElement | null) => void;
  helpIconBounds: RectReadOnly;
  acountRef: (node: HTMLElement | null) => void;
  acountBounds: RectReadOnly;
  tgemIconRef: (node: HTMLElement | null) => void;
  tgemIconBounds: RectReadOnly;
}

const IntroContext = createContext({} as UseIntroGuideReturnType);

export { IntroContext };
